<style scoped>
.requireText label:before{
  content: '* ';
  color: red;
}
</style>

<template>
  <div style="padding: 15px;width:100%">
    <Card >
      <Row>
        <Button class="" style="margin-bottom: 10px;" type="info" @click="backPage">返回</Button>
      </Row>
      <Col >
        <Row>
          <div style="display: flex;flex-direction: row;">
            <div style="margin-right: 20px;font-weight: bold;color:#000000; background-color: #FFFFFF;border-radius: 4px; padding: 2px 6px; font-size: 18px;"><span style="font-weight: bold; font-size: 18px;">序号：</span>{{ objcaiQ._index+1 }}
            </div>
            <div style="margin-right: 20px;font-weight: bold;color:#000000; background-color: #FFFFFF;border-radius: 4px; padding: 2px 6px; font-size: 18px;"><span style="font-weight: bold; font-size: 18px;">订单号：</span>{{ objcaiQ.code }}
            </div>
            <div style="margin-right: 20px;font-weight: bold;color:#000000; background-color: #FFFFFF;border-radius: 4px; padding: 2px 6px; font-size: 18px;"><span style="font-weight: bold; font-size: 18px;">产品名称：</span>{{ objcaiQ.name }}
            </div>
            <div style="margin-right: 30px;font-weight: bold;color:#000000; font-size: 18px;background-color: #FFFFFF;border-radius: 4px; padding: 2px 6px;"><span style="font-weight: bold;">裁切幅宽(mm):</span>{{ objcaiQ.sliceWide }}</div>
          </div>
        </Row>
        <Row>
          
          <div style="display: flex;flex-direction: row;">
            <!-- <div style="margin-right: 15px;"><span style="font-weight: bold;">裁切总长度:</span>{{ objcaiQ.splitsTotalLength }}
            </div> -->
            
            
            <div style="margin-right: 30px;font-weight: bold;color:#000000; font-size: 18px;background-color: #FFFFFF;border-radius: 4px; padding: 2px 6px;"><span style="font-weight: bold;">裁切长度(mm):</span>{{ objcaiQ.sliceLength*1000 }}</div>
            <div style="margin-right: 30px;font-weight: bold;color:#000000; font-size: 18px;background-color: #FFFFFF;border-radius: 4px; padding: 2px 6px;"><span style="font-weight: bold;">裁切张数:</span>{{ objcaiQ.sliceNo }}</div>
            <div style="margin-right: 30px;font-weight: bold;color:#000000; font-size: 18px;background-color: #FFFFFF;border-radius: 4px; padding: 2px 6px;"><span style="font-weight: bold;">备注:</span>{{ objcaiQ.remark }}
            </div>
              <Button class="" style="padding:2px 15px;background:rgb(60, 212, 151) !important;color:white;border-color :rgb(60, 212, 151) !important" type="primary" @click="okm">完成</Button>

          </div>
        </Row>
<Row>
  &nbsp;
</Row>
        <Row>
          <Form inline :label-width="90" class="basicForm" ref="searchFormEch" :model="searchFormEch">
         <FormItem class="form-item" label="物料编号" >
            <Input class="width90" type="text" clearable v-model.trim="searchFormEch.code"
              placeholder="请输入" />
          </FormItem>
            <FormItem class="form-item " label="" :label-width="0"
              style="width: 350px;">
              <Button class="" type="primary" @click="getCutPaperPasteOptFun" :loading="loading">查询</Button>
              <Button class="" type="primary" @click="searchBtnNew" :loading="loading">选择物料</Button>
              <!-- <Button class="" type="primary" @click="heChFun" :loading="loading">裁切</Button> -->
              <Button class="" type="primary" @click="searchBtn" >贴标</Button>
            </FormItem>
          </Form>
          <!-- <Row class="" style="display: flex;
          flex-direction: column;"> -->
          
        <!-- </Row> -->
        </Row>

        <Table class="table" border @on-selection-change="selectTab"  ref="tableDataOneTab" :data="tableDataOne" :columns="tableColumnsOne" :loading="loading" highlight-row
            stripe>
          </Table>
          <Row>
          <Page :current="pageNumcai" :page-size="pageSizecai" :total="totalcai" @on-change="handleChangePagecai"
          @on-page-size-change="handlePageSizeChangecai" show-total show-sizer
          style="margin-top:10px;text-align: center; margin-left: 40%;" />
          <div style="display: flex;flex-direction: row;align-items: center;margin-top: 10px;" >
                      <div style="margin-left: 300px;">累计裁切数：<Input class="" style="width: 90px; margin-right: 10px;"    type="number" clearable v-model.trim="sumNumber"
                        placeholder="请输入" /></div>
                      <div style="display: flex;flex-direction: row;align-items: center;margin-left: 15px;">
                        <div>每包张数：</div>
                        <Input class="" style="width: 120px; margin-right: 20px;"    type="number" clearable v-model.trim="paperNumber"
                          placeholder="请输入" />
                      </div>
              <Button class="" type="primary" @click="caiQieFun">裁切</Button>
                      
                    </div>
                  </Row>
        </Col>
    </Card>
    <Card style="margin-top: 15px;">
      <!-- <Col  style=""> -->
      <Row>
        <Form inline :label-width="110" class="basicForm" >
          
       <!--   <FormItem class="form-item" label="长">
            <Input class="width90" type="text" clearable v-model.trim="searchFormEch.spLengths"
              placeholder="请输入" />
          </FormItem>
          <FormItem class="form-item" label="类型">
            <Select v-model="searchFormEch.type" transfer clearable class="width160">
            <Option value="库存">库存</Option>
            <Option value="损耗">损耗</Option>
            <Option value="撤回">撤回</Option>
          </Select>
          </FormItem> -->
          <FormItem class="form-item" label="" :label-width="0" style="width: 185px;"><!--margin-left: 50px;-->
            <!-- <Button class="" type="primary" @click="getCutPaperPasteListFun" :loading="loading">查询</Button> -->
            <Button class="" type="primary" @click="searchBtnSSS" :loading="loading">贴标</Button>
          </FormItem>
          <FormItem style="margin-left: 800px;font-weight: bold;color:#000000; font-size: 18px;" class="form-item" label="裁切总数量:" >
            <div >{{ sliceNoObj.sliceNo }}</div>
          </FormItem>
          <FormItem style="font-weight: bold;color:#000000; font-size: 18px;" class="form-item" label="总包数:" >
            <div style="margin-right: 50px;">{{ sliceNoObj.packageNo }}</div>
          </FormItem>
        </Form>
      </Row>
      <!-- <Row class="" style="display: flex;
          flex-direction: column;"> -->
        <Table class="table" border :data="tableData" ref="tableDataSet" :columns="tableColumnRight" :loading="loading" highlight-row
          stripe>
        </Table>
        <Page :current="pageNum" :page-size="pageSize" :total="total" @on-change="handleChangePage"
          @on-page-size-change="handlePageSizeChange" show-total show-sizer
          style="margin-top:10px;text-align: center;" />
      <!-- </Row> -->
      <!-- </Col> -->
    </Card>
    <Modal :title="titleType" v-model="proSelectModals" width="1200" footer-hide style="display: flex;
      flex-direction: column;">
      <Form inline :label-width="80" class="basicForm" ref="proSelectForm">
        <FormItem class="form-item" label="类型">
          <Select v-model="proSelectForm.type" style="width: 120px;" transfer clearable class="width160">
            <Option value="原料">原料</Option>
            <Option value="一级">一级</Option>
            <Option value="二级">二级</Option>
            <Option value="成品">成品</Option>
          </Select>
        </FormItem>
        <FormItem class="form-item" label="物料编码">
          <Input class="width160" type="text" style="width: 120px;" clearable v-model.trim="proSelectForm.code" placeholder="请输入..." />
        </FormItem>
        <FormItem class="form-item" label="幅宽">
          <Input class="width160" type="text" style="width: 120px;" clearable v-model.trim="proSelectForm.splitsWide" placeholder="请输入..." />
        </FormItem>
        <FormItem class="form-item">
          <Button type="primary" @click="searchBtnNew">查询</Button>
        </FormItem>
      </Form>
      <Row class="marginTop20">
        <Table :height="600" class="table" ref="proSelectTab" border :data="proSelectData" :columns="proSelectColumns"
          highlight-row stripe>
        </Table>
      </Row>
      <Row style="margin-left:45%;margin-top: 10px;">
        <Button type="primary" @click="sureProBtn">添加</Button>
        <Button @click="proSelectModals = false" class="marginLeft20" style="width: 70px;margin-left: 20px;">取消</Button>
      </Row>

    </Modal>
    <Modal title="修改" v-model="changeEquipFlag" footer-hide>
      <Form :label-width="90" inline>
        <FormItem label="剩余长度" >
          <Input class="width160" type="text" style="width: 200px;" clearable v-model.trim="changeEquip.length" placeholder="请输入..." />
        </FormItem>
      </Form>
      <Row style="text-align: center;margin-left: 35%">
        <Button type="primary" @click="submitChangeEquip" style="width: 70px">确定</Button>
        <Button @click="changeEquipFlag = false" class="marginLeft20" style="width: 70px; margin-left:20px">取消</Button>
      </Row>
    </Modal>
    <Modal title="修改" v-model="allFormFlag" footer-hide>
      <Form :label-width="90" inline>
        <FormItem class="form-item" label="类型">
            <Select v-model="allForm.type" style="width: 200px;" class="width160">
            <Option value="库存">库存</Option>
            <Option value="损耗">损耗</Option>
            <Option value="撤回">撤回</Option>
          </Select>
          </FormItem>
      </Form>
      <Row style="text-align: center;margin-left: 35%">
        <Button type="primary" @click="submitAllForm" style="width: 70px">确定</Button>
        <Button @click="allFormFlag = false" class="marginLeft20" style="width: 70px; margin-left:20px">取消</Button>
      </Row>
    </Modal>
  </div>
</template>

<script>
import { formatDate } from "@/api/util";
import { getOverallList, getCutPaperPasteOpt,cutCommonDecals ,cutCommonFulfill,decalsSlice,getSliceNo,getGoodsStockListCC,getFulfillList,getSlicePageList,updateType,splitsGoodsStockOpt,saveRemLengths,cutPaperSliceMaterialV2PmB,saveGoodsslice,deleteSelectGoodsStocks, getPasteInfo,saveSliceMaterial,getGoodsStockList, cutPaperPasteOptAdd,getSplitsMaterialList,getRecallPastePaper,getPasteFinishList,updateCutPaperPasteOpt,pastePaper,getPartDeleteById } from '@/api/index'
export default {
  name: "caiQAdd",
  data() {
    return {
      searchFormEch:{},
      allForm:{},
      allFormFlag:false,
      processData: [],
      pageNum:1,
      pageSize:15,
      total:0,
      pageNumcai:1,
      pageSizecai:40,
      totalcai:0,
      searchForm: {},
      objFuhe: {},
      objcaiQ:{},
      tableData: [],
      paperNumber:null,
      sumNumber:0,
      proSelectData: [],
      proSelectForm:{},
      tableDataOne: [],
      tableDataTwo: [],
      tableDataThree: [],
      tableDataFour: [],
      proSelectModals: false,
      changeEquipFlag: false,
      
      titleType: '',
      loading: false,
      tableColumns: [
        {
          title: "序号",
          type: "index",
          width: 70,
          align: "center"
        },
        {
          key: "name",
          title: "工序",
          align: "center",
        },
        {
          key: "complete",
          title: "已完成",
          align: "center",
        },
        {
          key: "noComplete",
          title: "未完成",
          align: "center",
        },
        {
          key: "rate",
          title: "进度",
          align: "center",
          render: (h, params) => {
            let data = params.row.rate + '%';
            return h("span", data);
          }
        },
      ],
      tableColumnsOne: [
        {
          type: 'selection',
          align: 'center',
          width: 60,
          // fixed:'left'
        },
        {
            title: "类型",
            key: "type",
            align: "center",
            width: 180,
          },
        {
          key: "code",
          title: "物料编号",
          align: "center",
          // width: 300,
        },
        // {
        //   key: "name",
        //   title: "名称",
        //   align: "center",
        //   width: 300,
        // },
        {
          key: "wide",
          title: "宽(mm)",
          align: "center",
          width: 200,
        },
        {
          key: "length",
          title: "长度(mm)",
          align: "center",
          width: 200,
          render: (h, params) => {
          return h("span", params.row.length*1000);
          },
        },
        {
          title: '裁切宽(mm)',
          key: 'sliceWide',
          align: 'center',
          width: 150,
          // render: (h, params) => {
          //   let _this = this;
          //   return h('Input', {
          //     style: {
          //       width: '100%',
          //       textAlign: 'center'
          //     },
          //     props: {
          //       value: params.row.sliceWide || '',
          //       type: 'number'
          //     },
          //     on: {
          //       'on-change': e => {
          //         if (e.target.value !== '' && e.target.value !== null && e.target.value !== undefined) {
          //           params.row.sliceWide = Number(e.target.value);
          //         } else {
          //           params.row.sliceWide = e.target.value;
          //         }
          //         this.$set(_this.tableDataOne, params.index, params.row);

          //       }
          //     }
          //   });

          // }
        },
        {
          title: '裁切长(mm)',
          key: 'sliceLength',
          align: 'center',
          width: 150,
          // render: (h, params) => {
          //   let _this = this;
          //   return h('Input', {
          //     style: {
          //       width: '100%',
          //       textAlign: 'center'
          //     },
          //     props: {
          //       value: params.row.sliceLength || '',
          //       type: 'number'
          //     },
          //     on: {
          //       'on-change': e => {
          //         if (e.target.value !== '' && e.target.value !== null && e.target.value !== undefined) {
          //           params.row.sliceLength = Number(e.target.value);
          //         } else {
          //           params.row.sliceLength = e.target.value;
          //         }
          //         this.$set(_this.tableDataOne, params.index, params.row);

          //       }
          //     }
          //   });

          // }
        },
        {
          title: '可裁切数',
          key: 'sliceNo',
          align: 'center',
          width: 220,
          render: (h, params) => {
            let _this = this;
            return h('Input', {
              style: {
                width: '100%',
                textAlign: 'center'
              },
              props: {
                value: params.row.sliceNo || '',
                type: 'number'
              },
              on: {
                'on-change': e => {
                  if (e.target.value !== '' && e.target.value !== null && e.target.value !== undefined) {
                    params.row.sliceNo = Number(e.target.value);
                  } else {
                    params.row.sliceNo = e.target.value;
                  }
                  this.$set(_this.tableDataOne, params.index, params.row);

                }
              }
            });

          }
        },
        // {
        //   title: '每包张数',
        //   key: 'packageNo',
        //   align: 'center',
        //   width: 270,
        //   render: (h, params) => {
        //     let _this = this;
        //     return h('Input', {
        //       style: {
        //         width: '100%',
        //         textAlign: 'center'
        //       },
        //       props: {
        //         value: params.row.packageNo || '',
        //         type: 'number'
        //       },
        //       on: {
        //         'on-change': e => {
        //           if (e.target.value !== '' && e.target.value !== null && e.target.value !== undefined) {
        //             params.row.packageNo = Number(e.target.value);
        //           } else {
        //             params.row.packageNo = e.target.value;
        //           }
        //           this.$set(_this.tableDataOne, params.index, params.row);

        //         }
        //       }
        //     });

        //   }
        // },
        {
          title: "操作",
          key: "action",
          width: 274,
          fixed: 'right',
          align: "center",
          render: (h, params) => {
            return h("div", [
            // h(
            //     "button", {

            //       style: {
            //                               marginRight: "10px",
            //                               display:"inline",
            //                               cursor: 'pointer',
            //                               padding:"2px 6px",
            //                               background:'#FF9900',
            //                               color:"white",
            //                               // borderRadio:'5px',
            //                               border:"none",
            //                             },
            //     on: {
            //       click: () => {
            //         this.recallApplyCaiQ(params.row);
            //       }
            //     }
            //   },
            //     "裁切"
            //   ),
              h(
                "button", {

                  style: {
                                          marginRight: "10px",
                                          display:"inline",
                                          cursor: 'pointer',
                                          padding:"2px 6px",
                                          background:'#FF0000',
                                          color:"white",
                                          // borderRadio:'5px',
                                          border:"none",
                                        },
                on: {
                  click: () => {
                    this.recallApply(params.row);
                  }
                }
              },
                "删除"
              ),
              
              h(
                                    "button", {
                                       
                                      style: {
                                          marginRight: "10px",
                                          display:"inline",
                                          cursor: 'pointer',
                                          padding:"2px 6px",
                                          background:'#326CFB',
                                          color:"white",
                                          // borderRadio:'5px',
                                          border:"none",
                                        },
                                        on: {
                                            click: () => {
                                              this.changeEquipFlag = true
                                              this.changeEquip = JSON.parse(JSON.stringify(params.row))
                                            }
                                        }
                                    },
                                    "修改"
                                ),
            ]);
          }
        }
      ],
      changeEquip:{},
      tableColumnRight: [
        {
          type: 'selection',
          align: 'center',
          width: 60,
          // fixed: 'left'
        },
        // {
        //   key: "name",
        //   title: "名称",
        //   align: "center",
        //   // width: 150,
        // },
        {
          key: "oriCode",
          title: "原料编号",
          align: "center",
          // width: 150,
        },
        {
          key: "code",
          title: "物料编号",
          align: "center",
          // width: 150,
        },
       
        {
          key: "wide",
          title: "宽(mm)",
          align: "center",
          // width: 150,
        },
        {
          key: "length",
          title: "长(mm)",
          align: "center",
          // width: 150,
          render: (h, params) => {
          return h("span", params.row.length*1000);
        },
        },
        // {
        //   key: "phyLengths",
        //   title: "长(m)",
        //   align: "center",
        //   // width: 150,
        // },
        {
          key: "type",
          title: "类型",
          align: "center",
             render: (h, params) => {
            let data = "";
            let className = '';
            switch (params.row.type) {
              case "撤回":
                data = "撤回";
                className = 'grey';
                break;
              case "库存":
                data = "库存";
                className = '#3CD497';
                break;
                case "损耗":
                data = "损耗";
                className = '#FF964A';
                break;
            }
            return h(
             "button", {
                 style: {
                            marginRight: "10px",
                            display:"inline",
                            cursor: 'pointer',
                            padding:"2px 6px",
                            background:'none',
                            color:className,
                            // borderRadio:'5px',
                            border:className,
                          },
                attrs: {
                    class: className
                  }
            },
              data
            )
          }
        },
        {
          key: "packageNo",
          title: "数量（张）",
          align: "center",
          // width: 150,
        },
        {
          key: "packagNumber",
          title: "包号",
          align: "center",
          // width: 150,
        },
        // {
        //   title: "状态",
        //   key: "status",
        //   align: "center",
        //   // width: 100,
        //   render: (h, params) => {
        //     let data = "";
        //     let className = '';
        //     switch (Number(params.row.status)) {
        //       case 0:
        //         data = "撤销";
        //         className = '';
        //         break;
        //       case 1:
        //         data = "正常";
        //         className = '';
        //         break;
        //     }

        //     return h(
        //       "div", {
        //       attrs: {
        //         class: className
        //       }
        //     },
        //       data
        //     )
        //   }
        // },
        {
          key: "operateTime",
          title: "操作时间",
          align: "center",
          // width: 150,
        },
        {
          key: "operator",
          title: "操作人",
          align: "center",
          // width: 150,
        },
        {
          title: "操作",
          key: "action",
          width: 100,
          fixed: 'right',
          align: "center",
          render: (h, params) => {
            return h("div", [
            h(
                                    "button", {
                                       
                                      style: {
                                          marginRight: "10px",
                                          display:"inline",
                                          cursor: 'pointer',
                                          padding:"2px 6px",
                                          background:'#326CFB',
                                          color:"white",
                                          // borderRadio:'5px',
                                          border:"none",
                                        },
                                        on: {
                                            click: () => {
                                                this.allFormFlag = true
                                                this.allForm = JSON.parse(JSON.stringify(params.row))
                                            }
                                        }
                                    },
                                    "修改"
                                ),
            ]);
          }
        }
      ],
      proSelectColumns: [
        {
          type: 'selection',
          align: 'center',
          width: 60,
          // fixed:'left'
        },
        {
          title: "类型",
          key: "level",
          align: "center",
          width: 100,
          render: (h, params) => {
            let data = "";
            let className = '';
            switch (Number(params.row.level)) {
              case 0:
                data = "原料";
                // className = 'table-status  border-color-blue';
                break;
              case 1:
                data = "一级";
                // className = 'table-status  border-color-blue';
                break;
              case 2:
                data = "二级";
                // className = 'table-status border-light-red';
                break;
                case 3:
                data = "成品";
                // className = 'table-status border-light-red';
                break;
            }

            return h(
              "div", {
              attrs: {
                class: className
              }
            },
              data
            )
          }
        },
        {
          key: "code",
          title: "物料编号",
          align: "center",
          // width: 150,
        },
        // {
        //   key: "brand",
        //   title: "品牌",
        //   align: "center",
        //   // width: 150,
        // },
        {
          key: "wide",
          title: "宽(mm)",
          align: "center",
          // width: 150,
        },
        {
          key: "remLen",
          title: "长(m)",
          align: "center",
          // width: 150,
        },
        // {
        //   title: '克重(kg)',
        //   key: 'weight',
        //   align: 'center',
        //   width: "150",
        // },
      ],
      types: null,
      sliceNoObj:{},
      // sumLength:0,
    }
  },
  methods: {
    okm(){
       this.$Modal.confirm({
                title: "确认",
                content: "是否确认完成?",
                onOk: () => {
                  cutCommonFulfill({
                    id:this.objcaiQ.id,
                    type:3,
                  }).then( res => {
                    if(res.code == 200){
                      this.$Message.success('操作成功！');
                    }
                  })
                }
              });
    },
    caiQieFun(){
      const data1 = this.$refs.tableDataOneTab.getSelection();
      if(data1.length == 0){
        this.$Message.error('请勾选裁切的物料!');
        return
      }
      this.$Modal.confirm({
  title: "确认裁切",
  content: "您确认要裁切吗?",
  onOk: () => {
    let params ={
      cutPaperSliceMaterialV2s:data1,
      packageNo:this.paperNumber,
      totalNo:this.sumNumber
    }
    cutPaperSliceMaterialV2PmB(params)
      .then(res => {
        if (res.code == 200) {
          this.$Message.success('裁切成功!');
          this.getCutPaperPasteOptFun()
          this.getCutPaperPasteListFun()
          this.getSliceNoFun()
        }
      })
  }
});
    },
    selectTab(v) {
        const data = this.$refs.tableDataOneTab.getSelection();
        let sumLengths = 0
        data.map( item => {
          sumLengths+=Number(item.sliceNo)
        })
       this.sumNumber = sumLengths
      },
    getSliceNoFun(){
      getSliceNo({
        pId:this.objcaiQ.id,
      }).then( res => {
        if(res.code == 200){
          this.sliceNoObj = res.data
        }
      })
    },
    submitAllForm(){
      updateType({
        ...this.allForm
      }).then(res => {
        if(res.code == 200){
          this.$Message.success("操作成功")
          this.allFormFlag = false
          this.getCutPaperPasteListFun()
        }
      })
    },
    submitChangeEquip(){
      if(this.changeEquip.length <0){
        this.$Message.error("请输入长度")
        return;
      }
      saveRemLengths({
        ...this.changeEquip
      }).then(res => {
        if(res.code == 200){
          this.$Message.success("操作成功")
          this.changeEquipFlag = false
          this.getCutPaperPasteOptFun()
        }
      })
    },
    printRow(v){
      let params = {
            id: v.id,
          }
                getRecallPastePaper(params)
                    .then(res =>{
                         if(res.code == 200){
                             window.open(res.data.result,"_blank");
                         }
                    })
            },
    heChFun(){
      const data1 = this.$refs.tableDataOneTab.getSelection();
      if(data1.length == 0){
        this.$Message.error('请勾选需要复合的材料!');
        return
      }
      // if(!this.searchFormEch.pasteLength){
      //   this.$Message.error('请填写长度!');
      //   return
      // }
      splitsGoodsStockOpt(data1).then(res => {
        if(res.code == 200){
          this.$Message.success('复合成功!');
          this.getCutPaperPasteOptFun()
          this.getCutPaperPasteListFun()
        }
      })
    },
    getVal(v){
        console.log("22",v)
        if(!!this.sumNumber){
          this.ballNumber =  Math.floor(this.sumNumber/this.paperNumber)
        }
      },
    getCutPaperPasteListFun(){
      let params = {
        data: {
          parentId: this.objcaiQ.id,
          dataType:2,
        },
        pageNum:this.pageNum,
        pageSize:this.pageSize
      }
      getFulfillList(params).then(res => {
        if(res.code == 200){
          this.tableData = res.data.records
          this.total = res.data.total
        }
      })
    },
    recallApplyCaiQ(v) {

this.$Modal.confirm({
  title: "确认裁切",
  content: "您确认要裁切吗?",
  onOk: () => {
    let params =v
    params.oriCode = v.code
    saveGoodsslice(params)
      .then(res => {
        if (res.code == 200) {
          this.$Message.success('裁切成功!');
          this.getCutPaperPasteOptFun()
          this.getCutPaperPasteListFun()
          
        }
      })
  }
});

},
    recallApply(v) {

      this.$Modal.confirm({
        title: "确认删除",
        content: "您确认要删除吗?",
        onOk: () => {
          let params = {
            id: v.id,
          }
          deleteSelectGoodsStocks(params)
            .then(res => {
              if (res.code == 200) {
                this.$Message.success('删除成功!');
                this.getCutPaperPasteOptFun()
              }
            })
        }
      });

    },
    recallApplys(v) {

this.$Modal.confirm({
  title: "确认撤销",
  content: "您确认要撤销吗?",
  onOk: () => {
    let params = {
      id: v.id,
    }
    getRecallPastePaper(params)
      .then(res => {
        if (res.code == 200) {
          this.$Message.success('撤销成功!');
          this.getCutPaperPasteListFun()
        }
      })
  }
});

},
    sureProBtn() {
      const data = this.$refs.proSelectTab.getSelection();
      if (data.length === 0) {
        this.$Message.warning('请勾选数据！');
        return
      }
      let atr = []
      data.map(item => {
        item.parentId=this.objcaiQ.id
        item.goodsId = item.id
        item.productId = item.categoryId
        // atr.push({
          // id:item.id,
          //parentId:this.objcaiQ.id
        // })
        // item.mid = item.id
        // item.parentId = this.objcaiQ.id
      })
      // let params = {
      //   data
      // }
      saveSliceMaterial(data).then(res => {
        if (res.code == 200) {
          this.$Message.success('保存成功！');
          this.proSelectModals = false
          this.getCutPaperPasteOptFun()
        }
      })
    },
    handleChangePage(page) {
                this.pageNum = page;
                this.getCutPaperPasteListFun()
            },
            handlePageSizeChange(size) {
                this.pageSize = size;
                this.getCutPaperPasteListFun()
            },
            handleChangePagecai(page) {
                this.pageNumcai = page;
                this.getCutPaperPasteOptFun()
            },
            handlePageSizeChangecai(size) {
                this.pageSizecai = size;
                this.getCutPaperPasteOptFun()
            },
    searchBtnNew() {
      // this.types = type
      this.titleType = "添加物料";
      this.proSelectModals = true
      getGoodsStockListCC(
        {
        // data:{
          ...this.proSelectForm,
          spId: this.objcaiQ.id,
          goodsWide: this.objcaiQ.sliceWide,
        // },
        // pageNum:1,
        // pageSize:9999,
        // type: type
      }).then(res => {
        if (res.code == 200) {
          this.proSelectData = res.data
        }
      })
    },
    getCutPaperPasteOptFun() {
      getSlicePageList({
        data: {
          ...this.searchFormEch,
          parentId: this.objcaiQ.id,
          dataType:1,
        },
        pageNum: this.pageNumcai,
        pageSize: this.pageSizecai,
      }
      )
        .then(res => {
          if (res.code == 200) {
            this.tableDataOne = res.data.records;
            this.totalcai = res.data.total
          }
        })
    },
    searchBtnSSS(){
      const data = this.$refs.tableDataSet.getSelection();
      if (data.length === 0) {
        this.$Message.warning('请勾选数据！');
        return
      }
      let codeArr = []
      data.map(item => {
        let str = item.code.concat(!!this.objcaiQ.customer?`_${this.objcaiQ.customer}`:'')
        console.log("222",str,item.code);
        codeArr.push(str)
        // codeArr.push(item.code)
      })
      decalsSlice(data).then(res => {
        if (res.code == 200) {
          window.open(res.data.result,"_blank");
        }
      })
    },
    searchBtn(){
      const data = this.$refs.tableDataOneTab.getSelection();
      if (data.length === 0) {
        this.$Message.warning('请勾选数据！');
        return
      }
      let codeArr = []
      data.map(item => {
        /* let str = item.code.concat(!!this.objcaiQ.customer?`_${this.objcaiQ.customer}`:'')
        console.log("222",str,item.code); */
        codeArr.push(item.code)
      })
      cutCommonDecals(codeArr).then(res => {
        if (res.code == 200) {
          window.open(res.data.result,"_blank");
        }
      })
    },
    // searchBtn(){
    //   this.tableData = []
    //   let params = {
    //     ...this.searchForm,
    //     startTime:this.searchForm.startDate ?
    //       formatDate(this.searchForm.startDate, "yyyy-MM-dd hh:mm:ss") : "",
    //     endTime:this.searchForm.endDate ?
    //       formatDate(this.searchForm.endDate, "yyyy-MM-dd hh:mm:ss") : "",
    //   }
    //   getOverallList(params)
    //     .then(res => {
    //       if(res.code == 200){
    //           this.tableData = res.data;
    //       }
    //     })
    // },
    backPage() {
      this.$router.go(-1);
    },
    init() {
      // 初始化时间为当天
      let eTime = new Date();
      eTime.setHours("23");
      eTime.setMinutes("59");
      eTime.setSeconds("59");
      this.searchForm.endDate = eTime;
      let newTime = new Date();
      newTime.setHours("00");
      newTime.setMinutes("00");
      newTime.setSeconds("00");
      this.searchForm.startDate = newTime;


    },
  },
  mounted() {
    this.init()
    this.objcaiQ = JSON.parse(window.sessionStorage.getItem('objcaiQ'))
    this.getCutPaperPasteOptFun()
    this.getCutPaperPasteListFun()
    this.getSliceNoFun()
  }
}
</script>




// WEBPACK FOOTER //
// src/components/caiQAdd.vue